const playground = {
  title: 'Playground',
  description: 'Teste e explore a Knowledge Base em tempo real',
  welcomeMessage: 'Bem-vindo ao Playground da Knowledge Base!',
  welcomeDescription: 'Aqui você pode interagir diretamente com a Knowledge Base. Faça perguntas, teste cenários e explore as capacidades do sistema.',
  inputPlaceholder: 'Digite sua mensagem para a Knowledge Base...',
  sendMessage: 'Enviar mensagem',
  noWorkspaceSelected: 'Nenhum workspace selecionado',
  selectWorkspaceFirst: 'Selecione um workspace para começar a usar o Playground',
  connecting: 'Conectando...',
  connected: 'Conectado',
  disconnected: 'Desconectado',
  reconnecting: 'Reconectando...',
  connectionError: 'Erro de conexão',
  retryConnection: 'Tentar novamente',
  chatHistory: 'Histórico de Conversas',
  clearChat: 'Limpar Chat',
  error: 'Erro',
  typing: 'Digitando...',
  userJoined: '{username} entrou no chat',
  userLeft: '{username} saiu do chat',
  playgroundAI: 'Playground IA',
  you: 'Você',

  // Painel de histórico de conversas (v2)
  sidebar: {
    newChat: 'Nova conversa',
    search: 'Buscar conversa…',
    today: 'Hoje',
    yesterday: 'Ontem',
    last7Days: '7 dias anteriores',
    older: 'Anteriores',
    empty: 'Nenhuma conversa ainda',
    noResults: 'Nenhuma conversa encontrada',
  },

  // PlaygroundView specific
  view: {
    title: 'Playground',
    subtitle: 'Converse com a IA em tempo real',
    conversation: 'Conversa: ',
    newChat: 'Nova Conversa',
    settings: 'Configurações do Playground',
    shareConversation: 'Compartilhar conversa em PDF',
    emptyStateTitle: 'Como posso te ajudar com seu projeto?',
    emptyStateSubtitle: 'Escolha uma sugestão abaixo ou digite sua própria pergunta',
    emptyChatTitle: 'Chat Vazio',
    emptyChatSubtitle: 'Envie sua primeira mensagem para começar a conversa.',
    aiThinking: 'Pensando...',
    selectingAgents: 'Selecionando agentes...',
    sendButton: 'Enviar',
    inputPlaceholder: 'Digite sua mensagem para a IA...',
    keyboardShortcuts: 'Pressione Enter para enviar, Shift + Enter para nova linha',
    noLlmTitle: 'Nenhum modelo de LLM configurado',
    noLlmDescription: 'Para conversar no Playground é necessário definir um Modelo de LLM na Integração, ou escolher uma Integração como Modelo Padrão da organização.'
  },

  // Prompt suggestions
  suggestions: {
    projectAnalysis: {
      title: 'Análise do Projeto',
      description: 'Avalie pontos fortes, fracos e oportunidades',
      prompt: 'Faça uma análise detalhada do meu projeto, incluindo pontos fortes, fracos e oportunidades de melhoria'
    },
    executivePresentation: {
      title: 'Apresentação Executiva',
      description: 'Monte uma apresentação para stakeholders',
      prompt: 'Crie um esboço de apresentação executiva sobre meu projeto para stakeholders, incluindo métricas e próximos passos'
    },
    projectStory: {
      title: 'História do Projeto',
      description: 'Crie uma narrativa envolvente sobre o projeto',
      prompt: 'Conte a história do meu projeto de forma envolvente, destacando sua jornada, evolução e impacto no mercado'
    },
    competitorAnalysis: {
      title: 'Análise de Concorrentes',
      description: 'Compare com a concorrência e identifique diferenciação',
      prompt: 'Elabore uma análise comparativa dos principais concorrentes do meu projeto, incluindo diferenciação e posicionamento'
    },
    marketingStrategy: {
      title: 'Estratégia de Marketing',
      description: 'Desenvolva campanhas e identifique canais ideais',
      prompt: 'Sugira uma estratégia de marketing digital para meu projeto, incluindo canais, mensagens e público-alvo'
    },
    projectFAQ: {
      title: 'FAQ do Projeto',
      description: 'Gere perguntas frequentes com respostas',
      prompt: 'Crie uma lista de perguntas frequentes (FAQ) sobre meu projeto com respostas detalhadas para clientes'
    }
  },

  // ChatList specific
  chatList: {
    title: 'Histórico de Conversas',
    description: 'Gerencie suas sessões de chat com a Knowledge Base',
    newChat: 'Nova Conversa',
    noChatsYet: 'Nenhuma conversa ainda',
    createFirstChat: 'Crie sua primeira conversa ou envie uma mensagem para começar',
    renameChat: 'Renomear Conversa',
    archiveChat: 'Arquivar Conversa',
    deleteChat: 'Excluir Conversa',
    deleteConfirmTitle: 'Excluir conversa?',
    deleteConfirmDescription: 'Esta ação não pode ser desfeita. A conversa e todo o seu histórico serão excluídos permanentemente.',
    chatDeleted: 'Conversa excluída com sucesso',
    chatArchived: 'Conversa arquivada com sucesso',
    chatRenamed: 'Conversa renomeada com sucesso',
    chatCreated: 'Nova conversa criada',
    createError: 'Erro ao criar conversa',
    renameError: 'Erro ao renomear conversa',
    archiveError: 'Erro ao arquivar conversa',
    deleteError: 'Erro ao excluir conversa',
    emptyTitleError: 'Título não pode estar vazio',
    titleTooLongError: 'Título não pode ter mais de 255 caracteres',
    showFullHistory: 'Exibir Histórico completo',
    chatActions: 'Ações da conversa',
    messageCount: {
      singular: 'mensagem',
      plural: 'mensagens'
    },
    activeChats: {
      singular: 'chat ativo',
      plural: 'chats ativos'
    },
    timeAgo: 'Agora'
  },

  // ChatMessage specific
  message: {
    shareTitle: 'Compartilhar mensagem',
    favoriteTitle: 'Favoritar mensagem',
    copyTitle: 'Copiar mensagem',
    you: 'Você',
    aiResponseTitle: 'Resposta da IA - {name}'
  },

  // PlaygroundConfigDialog specific
  config: {
    title: 'Configurações do Playground',
    loading: 'Carregando configurações...',
    saving: 'Salvando...',
    saved: 'Configurações salvas',
    savedDescription: 'As configurações do Playground foram atualizadas com sucesso.',
    reset: 'Resetar',
    cancel: 'Cancelar',
    save: 'Salvar',
    tabs: {
      rag: 'RAG & IA',
      ui: 'Interface',
      restrictions: 'Restrições'
    },
    rag: {
      title: 'Configurações de RAG e IA',
      similarityThreshold: 'Limiar de Similaridade',
      maxResults: 'Máximo de Resultados',
      temperature: 'Temperatura',
      maxTokens: 'Máximo de Tokens',
      systemPrompt: 'Prompt do Sistema',
      systemPromptPlaceholder: 'Defina o comportamento e papel da IA...'
    },
    ui: {
      title: 'Configurações de Interface',
      welcomeMessage: 'Mensagem de Boas-vindas',
      welcomeMessagePlaceholder: 'Mensagem exibida quando o usuário abre o chat...',
      inputPlaceholder: 'Placeholder do Input',
      inputPlaceholderPlaceholder: 'Texto de placeholder do campo de entrada...',
      maxChatHistory: 'Máximo de Histórico no Chat'
    },
    restrictions: {
      title: 'Restrições e Limites',
      allowedFileTypes: 'Tipos de Arquivo Permitidos',
      allowedFileTypesPlaceholder: 'pdf, txt, docx, xlsx...',
      allowedFileTypesHelp: 'Separe os tipos de arquivo por vírgula',
      maxQueryLength: 'Tamanho Máximo de Consulta (caracteres)',
      rateLimitPerMinute: 'Limite de Consultas por Minuto'
    }
  },

  // Error messages
  errors: {
    general: 'Ocorreu um erro',
    sendMessage: 'Erro ao enviar mensagem',
    loadHistory: 'Erro ao carregar histórico do chat',
    loadConfig: 'Erro ao carregar configurações',
    saveConfig: 'Erro ao salvar configurações',
    subscriptionRequired: 'Assinatura Expirada/Esgotada - Adicione mais créditos ou contrate outro plano para continuar conversando.'
  },

  // No workspace state
  no_workspace: {
    title: 'Nenhum workspace selecionado',
    description: 'Selecione um workspace para começar a usar o Playground'
  },

  // Loading states
  loading: {
    history: {
      title: "Carregando histórico...",
      description: "Recuperando suas conversas anteriores com a IA"
    }
  },

  // Legacy support
  manageChatSessions: 'Gerencie suas sessões de chat com a Knowledge Base',
  newChat: 'Nova Conversa',
  creatingChat: 'Criando...',
  noChatsYet: 'Nenhuma conversa ainda',
  createFirstChat: 'Crie sua primeira conversa ou envie uma mensagem para começar',
  renameChat: 'Renomear Conversa',
  archiveChat: 'Arquivar Conversa',
  deleteChat: 'Excluir Conversa',
  deleteConfirmTitle: 'Excluir conversa?',
  deleteConfirmDescription: 'Esta ação não pode ser desfeita. A conversa e todo o seu histórico serão excluídos permanentemente.',
  chatDeleted: 'Conversa excluída com sucesso',
  chatArchived: 'Conversa arquivada com sucesso',
  chatRenamed: 'Conversa renomeada com sucesso',
  chatCreated: 'Nova conversa criada',
  emptyStateTitle: 'Bem-vindo ao Playground!',
  emptyStateDescription: 'Selecione uma conversa existente ou envie uma mensagem para começar uma nova.',
  emptyChat: 'Chat vazio',
  startConversation: 'Envie sua primeira mensagem para começar a conversa',
  no_agent_selected: "Digite sua pergunta para começar",
  ai_thinking: "A IA está processando sua pergunta...",

  // Chat structure
  chat: {
    input_placeholder: 'Digite sua mensagem para a Knowledge Base...',
    send: 'Enviar'
  },

  // MCP Tools discovery
  mcpTools: {
    title: 'MCP Tools',
    openDialog: 'Ver todas as ferramentas MCP e configuração',
    tabs: {
      integrations: 'Integrações',
      core: 'Ferramentas Core',
      config: 'Configuração'
    },
    integrations: {
      empty: 'Nenhuma integração com MCP tools instalada para este workspace.',
      toolCount_one: '{{count}} ferramenta',
      toolCount_other: '{{count}} ferramentas'
    },
    coreGroups: {
      contextKnowledge: 'Contexto & Conhecimento',
      agents: 'Agentes',
      integrations: 'Integrações',
      admin: 'Admin (SUPERADMIN / ADMIN)'
    },
    coreTools: {
      get_my_profile: 'Identidade do usuário autenticado, organização e preferências pessoais de IA.',
      get_workspace_info: 'Contexto completo do workspace (overview do knowledge base + integrações ativas).',
      update_my_ai_preferences: 'Atualiza as instruções pessoais de IA do usuário e o flag de confirmação destrutiva.',
      search_knowledge: 'Busca semântica (RAG) sobre o knowledge base.',
      list_agents: 'Lista os agentes de IA configurados para este workspace.',
      invoke_agent: 'Executa um agente Prodgy com seu próprio LLM, tools e prompt.',
      list_integration_catalog: 'Lista os templates de integração disponíveis.',
      list_installed_integrations: 'Integrações instaladas com status e ferramentas.',
      get_integration: 'Detalhes completos do template: auth, settings, mcp_config.',
      install_integration: 'Provisiona uma integração com credenciais e configurações.',
      create_integration: 'Cria um novo template de integração no catálogo.',
      update_integration: 'Atualiza um template de integração existente.',
      delete_integration: 'Remove um template de integração do catálogo.',
      get_mcp_settings: 'Lê as instruções e regras de export atuais do servidor MCP.',
      update_mcp_settings: 'Atualiza as instruções e regras de export do servidor MCP.'
    },
    config: {
      descriptionPrefix: 'Adicione este snippet à configuração do seu cliente MCP (',
      descriptionSuffix: ').',
      tokenHintPrefix: 'Gere um token em ',
      tokenHintBold: 'Configurações do Workspace → API Tokens',
      tokenHintSuffix: '.',
      copy: 'Copiar',
      copied: 'Copiado',
      copyFailed: 'Falha ao copiar para a área de transferência'
    }
  },

  // Embed Widget
  embedWidget: {
    title: 'Embedar Widget',
    subtitle: 'Incorporar chat widget para',
    embedButton: 'Embedar Widget',
    customize: 'Personalizar',
    widgetTitle: 'Título do Widget',
    width: 'Largura (px)',
    height: 'Altura (px)',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    embedCode: 'Código de Incorporação',
    iframeDescription: 'Cole este código na sua página HTML para incorporar o widget de chat.',
    scriptDescription: 'Adicione este script à sua página para um widget de chat flutuante automático.',
    directUrl: 'URL Direto',
    codeCopied: 'Código copiado',
    codeCopiedDescription: 'O código de incorporação foi copiado para a área de transferência.',
    copyFailed: 'Falha ao copiar'
  }
} as const;

export default playground;
